import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../../auth/AuthContext";
import { ChangePassword } from "../../components/ChangePassword";

const TABS = [
  { to: "/coach", label: "Attendance", end: true },
  { to: "/coach/reports", label: "Reports" },
];

export const CoachLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="coach-layout">
      <header className="sticky top-0 z-40 bg-black/90 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 h-20 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/logo-mark.png" alt="" className="h-16 w-auto" data-testid="coach-header-logo" />
            <span className="font-heading font-black tracking-tighter text-lg leading-none">
              ZAVI<span className="text-[#D4AF37]">FC</span>
              <span className="text-white/40 font-normal normal-case tracking-normal text-xs ml-3">Coach — {user?.name}</span>
            </span>
          </div>
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex flex-col items-end">
              <span className="text-white/40 text-xs">{user?.email}</span>
              <ChangePassword testid="coach-change-password" />
            </div>
            <button
              onClick={async () => { await logout(); navigate("/"); }}
              className="flex items-center gap-2 text-white/60 hover:text-[#D4AF37] text-xs uppercase tracking-widest transition-colors duration-200"
              data-testid="coach-logout"
            >
              <LogOut size={14} /> Logout
            </button>
          </div>
        </div>
        <nav className="max-w-7xl mx-auto px-4 lg:px-8 flex gap-1 overflow-x-auto" data-testid="coach-tabs">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={`coach-tab-${t.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-3 text-xs uppercase tracking-widest font-semibold whitespace-nowrap border-b-2 transition-colors duration-200 ${
                  isActive ? "border-[#D4AF37] text-[#D4AF37]" : "border-transparent text-white/50 hover:text-white"
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-7xl mx-auto px-4 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
};
